import {
	ChevronDoubleLeftIcon,
	ChevronDoubleRightIcon,
	ChevronLeftIcon,
	ChevronRightIcon,
	ClipboardDocumentListIcon,
	PlusIcon,
} from "@heroicons/react/20/solid";
import _ from "lodash";
import { useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { connect } from "react-redux";
import { Actions as LEAVEACTIONS } from "../../store/actions/leaveActions";
import IntegrationLeaveImport from "../integrations/IntegrationLeaveImport";
import ImportLeave from "./import-leave/applications/ImportLeave";
import ImportLeaveModal from "./import-leave/applications/ImportLeaveModal";
import LeaveTable from "./LeaveTable";
import MarkLeaveModal from "./MarkLeaveModal";

const TeamLeave = ({ leaveLoading, leave, setOpenModal, userPermissions, setOpenMarkLeaveModal }) => {
	const [itemsPerPage, setItemsPerPage] = useState(20);
	const [page, setPage] = useState(0);
	const start = page * itemsPerPage;
	const end = (page + 1) * itemsPerPage;
	const lastPage = Math.ceil(leave?.length / itemsPerPage);

	const Pagination = () => {
		if (leave.length <= 0) return null;
		return (
			<thead>
				<tr>
					<th colSpan={10}>
						<div
							style={{
								display: "grid",
								gridGap: "1.5rem",
								grid: "1.5rem",
								gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
							}}
						>
							<div style={{ gridColumn: "span 1 / span 3", textAlign: "center" }}>
								<button
									className="btn btn-xs btn-default pull-left"
									title="Go To Page 1"
									style={{ marginLeft: "0.5rem" }}
									onClick={() => {
										if (page != 0) setPage(0);
									}}
									disabled={page === 0}
								>
									<ChevronDoubleLeftIcon style={{ height: "1.5em", float: "left" }} />
								</button>
								<button
									className="btn btn-xs btn-default pull-left"
									title="Go Back 5 Pages"
									style={{ marginLeft: "0.5rem" }}
									onClick={() => {
										if (page != 0) setPage(Math.max(page - 5, 0));
									}}
									disabled={page === 0}
								>
									<ChevronDoubleLeftIcon style={{ height: "1.5em", float: "left" }} />
								</button>
								<button
									className="btn btn-xs btn-default pull-left"
									title="Go Back 1 Page"
									style={{ marginLeft: "0.5rem" }}
									onClick={() => {
										if (page != 0) setPage(page - 1);
									}}
									disabled={page === 0}
								>
									<ChevronLeftIcon style={{ height: "1.5em", float: "left" }} />
								</button>
							</div>
							<div style={{ gridColumn: "span 1 / span 3", textAlign: "center" }}>
								<strong>
									Page {page + 1}/{lastPage}
								</strong>
							</div>
							<div style={{ gridColumn: "span 1 / span 3", textAlign: "center" }}>
								<button
									className="btn btn-xs btn-default pull-right"
									style={{ marginRight: "0.5rem" }}
									title={`Go to Page ${lastPage}`}
									onClick={() => {
										if (page !== lastPage - 1) setPage(lastPage - 1);
									}}
									disabled={page === lastPage - 1}
								>
									<ChevronDoubleRightIcon style={{ height: "1.5em", float: "left" }} />
								</button>
								<button
									className="btn btn-xs btn-default pull-right"
									style={{ marginRight: "0.5rem" }}
									title="Go Forward 5 Pages"
									onClick={() => {
										if (page !== lastPage - 1) setPage(Math.min(page + 5, lastPage - 1));
									}}
									disabled={page === lastPage - 1}
								>
									<ChevronDoubleRightIcon style={{ height: "1.5em", float: "left" }} />
								</button>
								<button
									className="btn btn-xs btn-default pull-right"
									title="Go Forward 1 Page"
									onClick={() => {
										if (page !== lastPage - 1) setPage(page + 1);
									}}
									style={{ marginRight: "0.5rem" }}
									disabled={page === lastPage - 1}
								>
									<ChevronRightIcon style={{ height: "1.5em", float: "left" }} />
								</button>
							</div>
						</div>
					</th>
				</tr>
			</thead>
		);
	};

	return (
		<>
			<MarkLeaveModal />
			<div className="content">
				<ImportLeaveModal />
				<div>
					<IntegrationLeaveImport />
					<div
						className="col-xs-12 pl-0 pr-0"
						style={{ paddingBottom: "2rem" }}
					>
						<div className="pull-left">
							<h5>Leave Applications</h5>
						</div>
						{userPermissions != "Read" && (
							<>
								<div
									className="btn btn-success pull-right"
									onClick={() => setOpenModal(true, null)}
								>
									<PlusIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
									<div style={{ float: "left" }}> Add Leave Application </div>
								</div>
								<ImportLeave />
								<button
									type="button"
									className="btn btn-default pull-right mr-4"
									onClick={() => setOpenMarkLeaveModal()}
								>
									<ClipboardDocumentListIcon
										style={{ height: "1.5em", float: "left", marginRight: 5 }}
									/>
									<div style={{ float: "left" }}>Mark Leave</div>
								</button>
							</>
						)}
					</div>
				</div>

				<div className="clearfix" />
			</div>
			<LeaveTable location="leavePage" />
		</>
	);
};

const mapStateToProps = (state) => {
	const { leaveLoading, leaveUpdating, leave, leaveTypes, detailedReportDownloading } = state.leave;
	const { departments } = state?.company?.settings;

	//All the company's employee
	const employeeListWithSalary = state.employees?.employeeListWithSalary;

	const employeeOptions = employeeListWithSalary?.map((employee) => ({
		value: employee.id,
		label: `${employee.employeeName} ${employee.employeeSurname}`,
		jobType: employee.employmentTypeName,
	}));

	const leaveTypeOptions = leaveTypes?.map((leaveType) => ({
		value: leaveType.id,
		label: leaveType.name,
	}));

	const leaveStatusOptions = ["Approved", "Pending", "Cancelled", "Denied", "Deleted", "Pending Cancellation"].map(
		(i) => ({ value: i, label: i }),
	);

	const departmentOptions = departments?.map((department) => ({
		value: department.id,
		label: department.name,
	}));

	const sortedLeave = _.orderBy(leave, ["start", "employeeName", "employeeSurname"], ["desc", "asc", "asc"]);

	const jobTypeOptions = [
		{
			value: "Part-time",
			label: "Part-time",
		},
		{
			value: "Full-time",
			label: "Full-time",
		},
	];

	return {
		leaveLoading,
		leaveUpdating,
		leave: sortedLeave,
		employeeOptions,
		departmentOptions,
		leaveTypeOptions,
		leaveStatusOptions,
		jobTypeOptions,
		userPermissions: state?.permissions?.my?.permissions?.leave,
	};
};

const mapDispatchToProps = (dispatch) => ({
	setOpenModal: (status, leave) => dispatch(LEAVEACTIONS.setOpenModal(status, leave, true)),
	setOpenMarkLeaveModal: () => dispatch(LEAVEACTIONS.setMarkedLeaveModal(true)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TeamLeave);
